module.exports = __webpack_public_path__ + "img/Number=88.699e0905.png";